import React from 'react';
import ReactDOM from 'react-dom/client';
import InstallationCalculations from './InstallationCalculations';

const $root: HTMLElement | null = document.getElementById(
	'timken-tool-bearing-installation-calculations',
);

if ( $root ) {
	ReactDOM.createRoot( $root ).render(
		<React.StrictMode>
			<InstallationCalculations />
		</React.StrictMode>
	);
}
